import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  inject,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltip } from '@angular/material/tooltip';
import {
  CompanyDialog,
  CompanyDialogData,
} from '@app/features/companies/company-dialog/company-dialog';
import { CompanyLogoService } from '@app/features/companies/company-logo.service';
import { Company, companyStateLabel } from '@app/features/companies/company.model';
import { CompanyService } from '@app/features/companies/company.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { LucideBuilding2 } from '@lucide/angular';
import { Observable } from 'rxjs';
import { CompanyPictureColor } from '../company-picture-color/company-picture-color';

@Component({
  selector: 'app-menu-company',
  imports: [
    CommonModule,
    MatButtonModule,
    MatTooltip,
    MatMenuModule,
    FontAwesomeModule,
    CompanyPictureColor,
    LucideBuilding2,
  ],
  templateUrl: './menu-company.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./menu-company.scss'],
})
export class MenuCompany implements OnInit {
  readonly cdr = inject(ChangeDetectorRef);
  readonly companyService = inject(CompanyService);
  readonly companyLogoService = inject(CompanyLogoService);
  readonly dialog = inject(MatDialog);
  companies$: Observable<Company[]> = this.companyService.allCompanies$;
  companyLogos = new Map<string, string>();

  ngOnInit(): void {
    this.companies$.subscribe((companies) => {
      companies.forEach((company) => {
        this.companyLogoService.findById(company.id).subscribe({
          next: () => {
            const logoUrl = this.companyLogoService.getLogoSrcUrl(company.id);
            this.companyLogos.set(company.id, logoUrl);
            this.cdr.markForCheck();
          },
          // Une société sans logo répond 404 : rien à afficher.
          error: () => undefined,
        });
      });
    });
  }
  readonly stateLabel = companyStateLabel;

  /** Les sociétés se créent dans l'application des entités légales : la fiche s'ouvre sur l'une d'elles. */
  openCompanyDialog(company: Company) {
    const dialogRef = this.dialog.open<CompanyDialog, CompanyDialogData, Company>(CompanyDialog, {
      minWidth: '720px',
      maxWidth: '1024px',
      maxHeight: '90vh',
      disableClose: true,
      data: { companyId: company.id },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log('Dialog result:', result);
    });
  }
}
